import { z } from 'zod';
export const PackagingLevel = z.enum(['unit', 'block', 'box']);
export const CodeSource = z.enum(['scan', 'import']);
export const ScanCodeRequest = z.object({
    raw: z.string().min(1),
});
export const OrderCode = z.object({
    id: z.string(),
    orderItemId: z.string(),
    productId: z.string(),
    gtin: z.string(),
    serial: z.string(),
    crypto: z.string(),
    raw: z.string(),
    packagingLevel: PackagingLevel,
    unitsCount: z.number().int(),
    source: CodeSource,
    scannedBy: z.string(),
    scannedByEmail: z.string().nullable(),
    scannedAt: z.string(),
});
export const OrderCodeItemProgress = z.object({
    orderItemId: z.string(),
    productId: z.string(),
    productName: z.string(),
    unit: z.string(),
    qty: z.string(),
    requiresMarking: z.boolean(),
    hasGtins: z.boolean(),
    expectedUnits: z.number().int(),
    scannedUnits: z.number().int(),
    remainingUnits: z.number().int(),
    isComplete: z.boolean(),
    byLevel: z.object({
        unit: z.number().int(),
        block: z.number().int(),
        box: z.number().int(),
    }),
});
export const OrderCodesState = z.object({
    status: z.string(),
    canScan: z.boolean(),
    wasBackToPicking: z.boolean(),
    items: z.array(OrderCodeItemProgress),
    codes: z.array(OrderCode),
    totals: z.object({
        expectedUnits: z.number().int(),
        scannedUnits: z.number().int(),
        isComplete: z.boolean(),
    }),
});
export const ScanCodeResponse = z.object({
    ok: z.literal(true),
    code: OrderCode,
    item: OrderCodeItemProgress,
    totals: OrderCodesState.shape.totals,
    autoFinalized: z.boolean(),
});
/**
 * Диапазон статусов заказа, в которых разрешён набор кодов маркировки
 * (скан / загрузка файла / удаление скана). Всё от «Отправлен» до включительно
 * «Подбор кодов». В completing_in_1c и дальше набор запрещён.
 */
export const CODE_PICKING_STATUSES = ['active', 'sent_to_warehouse', 'picking_codes'];
export function canPickCodes(status) {
    return CODE_PICKING_STATUSES.includes(status);
}
//# sourceMappingURL=codes.js.map